import * as React from 'react';

interface IProps {
  color?: any;
}

export default ({ color = 'dark' }: IProps) => <img src="/assets/logo/remote-family.png" width="200" alt="Remote Family Logo" />;
